import { StyleSheet, TextInput, View } from "react-native";
import { Text } from "react-native-paper";

import { colors, fonts, radius, spacing } from "@/lib/theme";

interface Props {
    value: string; // digits-only, max 10
    onChange: (digits: string) => void;
    placeholder?: string;
    autoFocus?: boolean;
    error?: string | null;
}

function formatGroup(digits: string): string {
    const d = digits.replace(/\D/g, "").slice(0, 10);
    if (d.length <= 3) {
        return d;
    }
    if (d.length <= 6) {
        return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    }
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function UsPhoneInput({ value, onChange, placeholder, autoFocus, error }: Props) {
    return (
        <View>
            <View style={[styles.row, error ? styles.rowError : null]}>
                <Text style={styles.prefix}>+1</Text>
                <TextInput
                    style={styles.input}
                    value={formatGroup(value)}
                    onChangeText={(t) => onChange(t.replace(/\D/g, "").slice(0, 10))}
                    keyboardType="number-pad"
                    placeholder={placeholder ?? "(555) 555-5555"}
                    placeholderTextColor={colors.textTertiary}
                    maxLength={14}
                    autoFocus={autoFocus}
                />
            </View>
            {error ? <Text style={styles.error}>{error}</Text> : null}
        </View>
    );
}

export function isValidUsPhone(value: string): boolean {
    return value.replace(/\D/g, "").length === 10;
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        borderColor: colors.surfaceBorder,
        borderRadius: radius.md,
        backgroundColor: colors.backgroundSecondary,
        paddingHorizontal: spacing.md,
        paddingVertical: spacing.sm
    },
    rowError: {
        borderColor: colors.error500
    },
    prefix: {
        fontFamily: fonts.regular,
        fontSize: 16,
        color: colors.textSecondary,
        marginRight: spacing.sm
    },
    input: {
        flex: 1,
        fontFamily: fonts.regular,
        fontSize: 16,
        color: colors.textPrimary,
        paddingVertical: 0
    },
    error: {
        marginTop: spacing.xs,
        fontFamily: fonts.regular,
        fontSize: 12,
        color: colors.error500
    }
});
